export default __webpack_public_path__ + "static/media/jpgLogo.4b2be37b.svg";